import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-photo",
  "use": "add-photo-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"add-photo\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5.5v3h3v2h-3v2.99s-1.99.01-2 0V5.5h-3s.01-1.99 0-2h3v-3h2zm-2 19h-14v-14h9v-2h-9c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L4 17.5h11l-3.54-4.71-2.75 3.54z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol